import type { Editor } from "@tiptap/core";
import type { LinkRange } from "./fileLinkEditor";

export type PendingFileLinkSelection = LinkRange & {
  text: string;
};

let pendingSelection: PendingFileLinkSelection | null = null;
let lastNonEmptySelection: PendingFileLinkSelection | null = null;

export function rememberEditorTextSelection(editor: Editor): PendingFileLinkSelection | null {
  const { from, to, empty } = editor.state.selection;

  if (empty || from === to) {
    return null;
  }

  const text = editor.state.doc.textBetween(from, to, " ");
  const entry: PendingFileLinkSelection = { from, to, text };

  pendingSelection = entry;
  lastNonEmptySelection = entry;

  return entry;
}

export function getPendingFileLinkSelection(): PendingFileLinkSelection | null {
  return pendingSelection ?? lastNonEmptySelection;
}

export function clearPendingFileLinkSelection() {
  pendingSelection = null;
}
